import * as React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { Helmet } from "react-helmet";
import { withToastManager } from "react-toast-notifications";

/** GraphQL */
import { listReportsWithCategories } from "src/graphql/custom-queries";
/** Presentation/UI */
import Table from "../../Components/Table";
import StyledButton from "../../Components/Styled/Button";
import Link from "../../Components/Styled/Link";
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import PageLoader from "../../Components/PageLoader";
import {
  TableHeader,
  TableHeaderContainer
} from "../../Components/Styled/ListViewElements";
import { MdSearch } from "react-icons/md";
import Logo from "../../Components/Layouts/LogoWrapper";

/** Themes */
import { Colors, Images } from "../../Themes";

/** Custom Types */
import { ToastNotificationType } from "../../CustomTypes";
import { TableConsts } from "src/Utils/Consts";

type Props = {
  toastManager: ToastNotificationType;
};

type State = {
  importModal: boolean;
  searchFilter: boolean;
  selected: any;
};

class Reports extends React.Component<Props> {
  state: State = {
    importModal: false,
    searchFilter: false,
    selected: null
  };

  toggleSearchFilter = (): void => {
    this.setState({ searchFilter: !this.state.searchFilter });
  };

  /** Success notification */
  toastNotification = (message: string, appearance?: string) => {
    this.props.toastManager.add(message, {
      appearance: appearance ? appearance : "success",
      autoDismiss: true
    });
  };

  render() {
    const { searchFilter } = this.state;
    return (
      <BackendWrapper>
        <Query
          query={gql(listReportsWithCategories)}
          variables={{ limit: TableConsts.limit }}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return <PageLoader />;
            }
            if (error) {
              return <div>There was a problem loading your data</div>;
            }

            if (!data || !data.listReports) {
              return <div>There are no Reports at the moment</div>;
            }

            return (
              <React.Fragment>
                <TableHeaderContainer>
                  <TableHeader>
                    <span>Manage Reports</span>
                  </TableHeader>
                  <Link
                    to={{
                      pathname: "/admin-reports/add",
                      params: {
                        notification: this.toastNotification
                      }
                    }}
                    label={
                      <StyledButton
                        type="button"
                        label="Create Report"
                        width="120px"
                        color={Colors.coal}
                        background={Colors.background}
                      />
                    }
                  />
                  <StyledButton
                    type="button"
                    label={<MdSearch size="1.3em" color={Colors.secondary} />}
                    width="auto"
                    margin="0px 10px"
                    onClick={this.toggleSearchFilter}
                    color={searchFilter ? Colors.background : Colors.coal}
                    background={
                      searchFilter ? Colors.default : Colors.background
                    }
                  />
                </TableHeaderContainer>
                <Table
                  data={data.listReports.items}
                  getTdProps={(
                    state: any,
                    rowInfo: { [key: string]: string }
                  ) => {
                    return {
                      onClick: (e: any) => {
                        if (rowInfo) {
                          // TODO: This is going to be a edit link
                        }
                      }
                    };
                  }}
                  columns={[
                    {
                      id: "logo",
                      Header: "",
                      accessor: (item: { [key: string]: any }) => {
                        return <Logo image={Images.pdfIcon} width="20px" />;
                      }
                    },
                    {
                      Header: "Report Name",
                      accessor: "name",
                      sortable: true,
                      filterable: searchFilter
                    },
                    {
                      id: "numberOfCategories",
                      Header: "Number of categories",
                      accessor: (item: { [key: string]: any }) => {
                        return item.categories.items.length > 0
                          ? item.categories.items.length
                          : "-";
                      },
                      sortable: true
                    },
                    {
                      id: "price",
                      Header: "Price",
                      accessor: (item: { [key: string]: any }) => {
                        return item.price ? "R" + item.price : "-";
                      },
                      sortable: true
                    },
                    {
                      Header: "Published Date",
                      accessor: "datePublished",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Purchases",
                      accessor: "placeholder",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Status",
                      accessor: "status",
                      sortable: true,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={TableConsts.defaultRows}
                  showPaginationBottom={
                    data.listReports.items.length > TableConsts.defaultRows
                  }
                />
              </React.Fragment>
            );
          }}
        </Query>
        <Helmet title="Manage Reports" />
      </BackendWrapper>
    );
  }
}

export default withToastManager(Reports);



// WEBPACK FOOTER //
// ./src/Containers/Reports/index.tsx